import { BasePage } from '@/components/ui/base-page'

export function PortfolioPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add PortfolioPage specific content here */}
    </BasePage>
  )
}